<template>
  <div class="relative h-full max-h-full w-full max-w-full">
    <Doughnut
      v-if="Array.isArray(chartData.datasets)"
      id="my-chart-id"
      :options="chartOptions"
      :data="chartData"
    />
  </div>
</template>

<script>
// https://vue-chartjs.org/examples/
import { Doughnut } from 'vue-chartjs'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement
)

export default {
  name: 'DoughnutChart',
  components: {
    Doughnut
  },
  props: {
    chartData: {
      type: Object,
      required: true
    },
    groupBy: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          x: {
            display: false
          }
        }
      }
    }
  },
  watch: {
    groupBy(newVal) {
      // Update the chart options reactively when groupBy changes
      this.chartOptions.scales.x.display = newVal === 'periode'
    }
  }
}
</script>

<style scoped></style>
